import winston, { createLogger, format } from 'winston';

const ddLogger = createLogger({
  level: 'info',
  exitOnError: false,
  defaultMeta: {
    service: process.env.NEXT_PUBLIC_DATADOG_SERVICE,
    env: process.env.NEXT_PUBLIC_HI_ENV,
  },
  format: format.combine(
    // Add Datadog tags directly in the format chain
    format((info) => ({
      ...info,
      ddtags: `env:${process.env.NEXT_PUBLIC_HI_ENV}`,
    }))(),
    format.errors({ stack: true }),
    format.json()
  ),
  transports: [
    new winston.transports.Console({
      level: 'info',
      format: format.json(),
    }),
  ],
});

export const serverLogger = {
  info: (message, ...args) => {
    ddLogger.info(message, { ...args });
  },
  warn: (message, err = {}, ...args) => {
    ddLogger.warn(message, { ...args, error: err });
  },
  error: (message, err = {}, ...args) => {
    ddLogger.error(message, { ...args, error: err });
  },
};
